import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M363.59 229.679v-116.09a113.59 113.59 0 0 0-227.18 0v116.09a159.026 159.026 0 1 0 227.18 0m-181.744-116.09a68.154 68.154 0 0 1 136.308 0v83.83a156.07 156.07 0 0 0-136.308 0ZM250 454.36a113.59 113.59 0 1 1 113.59-113.59A113.59 113.59 0 0 1 250 454.36" }, null, -1),
    _createElementVNode("path", { d: "M284.077 323.731a34.08 34.08 0 0 1-11.359 25.217v20.22a22.718 22.718 0 0 1-45.436 0v-20.22a34.077 34.077 0 1 1 56.795-25.217" }, null, -1)
  ])))
}
export default { render: render }